module.exports = new __parcel__URL__("C9O1.76bde05f.png").toString();